import React, { useEffect, useState } from "react";
import DashboardGraph from "../../Components/Dashboard/DashboardGraph";
import BarGraph from "../../Components/Dashboard/BarGraph";
import BugRatio from "../../Components/Dashboard/BugRatio";
import SubtaskBugsTable from "../../Components/Dashboard/SubtaskBugsTable";
import BugDistributionPieChart from "../../Components/Dashboard/BugDistributionPieChart";
import { 
  getDashboardByProjGuid, 
  getBugsStatsByUser, 
  getBugCountsByProject, 
  getBugsByProjId,
  getTimeReportDownloadUrl
} from "../../services/homeService";
import loginData from "../BugList/userLoginIds.json";
import "./BugDashboard.css";
import { useDispatch, useSelector } from "react-redux";
import { setDashboardDataByprojId } from "../../store/slice/dashboardSlice";
import { Base64 } from 'js-base64'; // Importing Base64 from js-base64
import { useParams } from "react-router-dom";
import SharePopup from "../../Components/Popup/SharePopup";
import Header from "../../Components/Navbar/Header";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { getCookie } from "../../services/utils.js";


const BugDashboard = () => {
  const { dashboardDataByprojId } = useSelector((state) => { return state.dashboardDetails });
  const { selectedProject } = useSelector((state) => { return state.bugDetails });
  const [openShare, setOpenShare] = useState(false);
  const [userBugsData, setUserBugsData] = useState([]);
  const [loadingUserStats, setLoadingUserStats] = useState(false);
  const [bugCounts, setBugCounts] = useState(null);
  const [allProjectBugs, setAllProjectBugs] = useState([]);
  const [loadingBugCounts, setLoadingBugCounts] = useState(false);
  const { guid } = useParams();
  const dispatch = useDispatch();  
  const getDashboardByProjGuidApi = async (projGuid) => {
    try {
      const resp = await getDashboardByProjGuid(projGuid);
      dispatch(setDashboardDataByprojId(resp))
    } catch (error) {
      console.error("Error fetching clients:", error.message);
    }
  }

  const getUserBugsStatsApi = async (projectId) => {
    try {
      setLoadingUserStats(true);
      const resp = await getBugsStatsByUser(projectId);
      setUserBugsData(resp || []);
    } catch (error) {
      console.error("Error fetching user bugs stats:", error.message);
      setUserBugsData([]);
    } finally {
      setLoadingUserStats(false);
    }
  }
  
  // Get bug counts data for pie chart
  const getBugCountsApi = async (projectId) => {
    try {
      setLoadingBugCounts(true);
      // Fetch bug counts (valid, invalid, total)
      const bugCountsData = await getBugCountsByProject(projectId);
      setBugCounts(bugCountsData);
      
      // Also fetch all bugs for this project to identify reviewer bugs
      const allBugs = await getBugsByProjId(projectId);
      setAllProjectBugs(allBugs || []);
    } catch (error) {
      console.error("Error fetching bug counts:", error.message);
      // Set default values when error occurs or no bugs exist
      setBugCounts({
        validBugsCount: 0,
        invalidBugsCount: 0,
        totalBugsCount: 0
      });
      setAllProjectBugs([]);
    } finally {
      setLoadingBugCounts(false);
    }
  }
  const encodedProjectGuid = Base64.encode(dashboardDataByprojId?.guId);

  const handleShare = () => {
    setOpenShare(true)
  }

  const handleDownloadTimeReport = () => {
    // Get the project ID for the report
    const projectId = dashboardDataByprojId?.id || selectedProject?.id;
    
    if (!projectId) {
      console.error('No project ID available for time report download');
      alert('Project information not available. Please try again later.');
      return;
    }
    
    // Get the download URL
    const downloadUrl = getTimeReportDownloadUrl(projectId);
    
    // Open the download URL in a new window/tab
    window.open(downloadUrl, '_blank');
  }

  const handleDownloadPDF = () => {
    const pageElement = document.getElementById('main-page');
    const fileName = selectedProject?.name + '.pdf';
    if (!pageElement) {
      console.error('Page container element not found');
      return;
    }
    //set height of featureWiseBugs table with scroll
    const featureWiseBugsElem = document.getElementById('featureWiseBugs');
    const featureWiseBugsHeightOriginal = featureWiseBugsElem.style.height;
    const featureWiseBugsHeight = featureWiseBugsElem.scrollHeight;
    featureWiseBugsElem.style.height = `${featureWiseBugsHeight}px`;

    //set height of featureWiseBugs table with scroll and header
    const featureWiseBugsTableElem = document.getElementById('featureWiseBugsTable');
    const featureWiseBugsHeightTableOriginal = featureWiseBugsTableElem.style.height;
    const featureWiseBugsTableCombine = (featureWiseBugsElem.offsetHeight) + 50 ;
    featureWiseBugsTableElem.style.height = `${featureWiseBugsTableCombine}px`;

    //set height of Top 5 bugs table with scroll
    const top5bugsElem = document.getElementById('top5bugs');
    const top5bugsHeightOriginal = top5bugsElem.style.height;
    const top5bugsHeight = top5bugsElem.scrollHeight;
    top5bugsElem.style.height = `${top5bugsHeight}px`;

    //set height of  Top 5 bugs table with scroll and header
    const top5bugsTableElem = document.getElementById('top5bugsTable');
    const top5bugsHeightTableOriginal = top5bugsTableElem.style.height;
    const top5bugsTableCombine = (top5bugsElem.offsetHeight) + 50;
    top5bugsTableElem.style.height = `${top5bugsTableCombine}px`;
  
    // Calculate the total height of the page
    const pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight,
      document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    // Set the height of the canvas to the total height of the page
    const canvasHeight = pageHeight + featureWiseBugsHeight;
  
    // Use setTimeout to wait for the table to adjust its height
    setTimeout(() => {
      html2canvas(pageElement, { scrollY: -window.scrollY, height: canvasHeight }).then(canvas => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = pdf.internal.pageSize.getWidth();
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
        pdf.save(fileName);

        //set the height of featureWiseBugs and Top 5 bugs to be in previous default height
        featureWiseBugsTableElem.style.height = featureWiseBugsHeightTableOriginal
        featureWiseBugsElem.style.height = featureWiseBugsHeightOriginal;
        top5bugsTableElem.style.height = top5bugsHeightTableOriginal
        top5bugsElem.style.height = top5bugsHeightOriginal;
      });
    }, 500);
  };
  

  const handleCloseShare = () => {
    setOpenShare(false)
  }

  useEffect(() => {
    if (guid) {
      const decodedGuid = Base64.decode(guid);
      getDashboardByProjGuidApi(decodedGuid);
    }
  }, [guid])

  // Separate useEffect for user stats that depends on project data
  useEffect(() => {
    const projectId = selectedProject?.id || dashboardDataByprojId?.projectId;
    if (projectId) {
      getUserBugsStatsApi(projectId);
      getBugCountsApi(projectId);
    }
  }, [selectedProject?.id, dashboardDataByprojId?.projectId])

  const userRole = getCookie('role')


  return (
    <>
      {guid && <Header />}
      <div style={{ padding: guid ? '0px 30px 30px 30px' : '' }} id="page-content">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: guid ? '70px' : '' }}>
          <h1 className="heading">Dashboard</h1>
          {
            !guid && (
              <div style={{display:"flex", gap:"10px"}}>
                <button disabled={userRole === 'CONTRACTOR'} className="shareBtn" onClick={handleShare}>Share</button>
                <button disabled={userRole === 'CONTRACTOR'} className="shareBtn" onClick={handleDownloadPDF}>PDF</button>
                <button disabled={userRole === 'CONTRACTOR'} className="shareBtn" style={{width: "120px"}} onClick={handleDownloadTimeReport}>Time Report</button>
              </div>
            )
          }
        </div>
        <DashboardGraph dashboardDataByprojId={dashboardDataByprojId} guid={guid}/>
        <div className="charts-row">
          <BarGraph dashboardDataByprojId={dashboardDataByprojId} />
          
            <BugDistributionPieChart 
              bugCounts={bugCounts} 
              bugsData={allProjectBugs} 
            />
        
        </div>
        <SubtaskBugsTable 
          userBugsData={userBugsData} 
          allProjectBugs={allProjectBugs} 
          loading={loadingUserStats || loadingBugCounts}
          approvers={loginData.login} 
        />
        <BugRatio dashboardDataByprojId={dashboardDataByprojId} />
        {
          openShare && (
            <SharePopup open={openShare}
              handleClose={handleCloseShare}
              title={"Dashboard link for this project"}
              data={`${process.env.REACT_APP_SHARE_URL}report/${encodedProjectGuid ? encodedProjectGuid : 'undefined'}`}
            />
          )
        }
      </div>
    </>
  );
};

export default BugDashboard;
